import { useTranslation } from 'react-i18next';

import { Paragraph } from '@app/shared/ui/atoms/Common';

interface ModalTextProps {
  translationKeys: readonly string[];
}

export function ModalText({ translationKeys }: ModalTextProps) {
  const { t } = useTranslation();

  return translationKeys.map((key) => (
    <Paragraph key={key} variant="white">
      {t(key)}
    </Paragraph>
  ));
}
